// tslint:disable:object-literal-sort-keys
import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";

import clsx from "clsx";

// import logo from './Adcon_Logo_RGB.png';
// import logo from "./OTT_HydroMet_Logo_RGB_web.png";
import { ReactComponent as AdconLogo } from "./ADCON_Logo_RGB.svg";
import { ReactComponent as OttHydrometLogo } from "./OTT_HydroMet_Logo_RGB_color.svg";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logoLink: {
      // ...defaultFont,
      // textTransform: 'uppercase',
      // padding: `${theme.spacing(1)}px`,
      // display: 'block',
      fontSize: "18px",
      textAlign: "left",
      fontWeight: 400,
      lineHeight: "30px",
      textDecoration: "none",
      backgroundColor: "transparent",
      "&,&:hover": {
        color: "#000000",
      },
    },
    img: {
      maxWidth: "100%",
      // display: 'block',
      // height: "auto",
      // maxHeight: "32px",
      // height: "32px",
      height: "24px",

      verticalAlign: "middle",
      // border: '0'
    },
    paddingLeft: {
      paddingLeft: theme.spacing(1),
    },
    paddingRight: {
      paddingRight: theme.spacing(1),
    },
  })
);

interface Props {}

function BrandFooter(props: Props) {
  const classes = useStyles(props);

  return (
    <>
      <a
        href="https://www.adcon.com"
        className={classes.logoLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <AdconLogo className={clsx(classes.img, classes.paddingRight)} />
      </a>
      <Typography variant="caption" noWrap component="span">
        Meteorology Division of
      </Typography>
      <a
        href="https://www.otthydromet.com"
        className={classes.logoLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <OttHydrometLogo
          className={clsx(
            classes.img,
            classes.paddingLeft,
            classes.paddingRight
          )}
        />
        {/* <img src={logo} alt="logo" className={classes.img} /> */}
        <Typography variant="body1" noWrap component="span">
          Copyright &copy; 2021
        </Typography>
      </a>
    </>
  );
}

export default BrandFooter;
